import { Expose } from 'class-transformer';

export class CardTypeMembershipFeeApiModel {
  @Expose()
  feeId: string;

  @Expose()
  name: string;

  @Expose()
  extensionTime: number;

  @Expose()
  extensionType: number;

  @Expose()
  feeValue: number;

  @Expose()
  purchasableDaysBeforeExpirationDate: number;
}
